/* Dreadlocks Center — recalcul automatique de la mensualité Klarna.
   Panier : suit le total du panier. Produit : suit la variante et la quantité. */
(function () {
  'use strict';
  if (window.__dreadKlarnaReady) return;
  window.__dreadKlarnaReady = true;

  /* Reproduit le format monetaire de la boutique (shop.money_format) pour que
     l'affichage JS soit identique au rendu Liquid. */
  function group(number, decimals, thousands, decimal) {
    var value = (Number(number) / 100).toFixed(decimals);
    var parts = value.split('.');
    var intPart = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
    return decimals && parts[1] ? intPart + decimal + parts[1] : intPart;
  }

  function formatMoney(cents, format) {
    cents = Number(cents) || 0;
    var fmt = format || '{{amount}}';
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, fmt);
      }
      return (cents / 100).toFixed(2);
    }
    var value;
    switch (match[1]) {
      case 'amount':                        value = group(cents, 2, ',', '.'); break;
      case 'amount_no_decimals':             value = group(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator':    value = group(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = group(cents, 0, '.', ','); break;
      case 'amount_with_space_separator':    value = group(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = group(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = group(cents, 2, "'", '.'); break;
      default:                               value = group(cents, 2, ',', '.');
    }
    return fmt.replace(match[0], value);
  }

  function render(el, amount) {
    var n = parseInt(el.getAttribute('data-instalments'), 10) || 3;
    var min = parseInt(el.getAttribute('data-min'), 10) || 0;
    var max = parseInt(el.getAttribute('data-max'), 10) || 0;
    amount = Number(amount) || 0;

    var hide = amount <= 0 || (min > 0 && amount < min) || (max > 0 && amount > max);
    el.hidden = hide;
    if (hide) return;

    var per = Math.ceil(amount / n);
    var out = el.querySelector('[data-dread-klarna-amount]');
    if (out) out.textContent = n + 'x ' + formatMoney(per, el.getAttribute('data-money-format'));
    el.setAttribute('data-amount', String(amount));
  }

  function nodes(ctx) {
    return document.querySelectorAll('[data-dread-klarna][data-context="' + ctx + '"]');
  }

  /* ---------- panier ---------- */
  function updateCart(total) {
    Array.prototype.forEach.call(nodes('cart'), function (el) { render(el, total); });
  }

  function fetchCart() {
    if (!nodes('cart').length) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && typeof c.total_price === 'number') updateCart(c.total_price); })
      .catch(function () {});
  }

  ['cart:updated', 'cart:refresh', 'cart:build', 'cart:change'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var c = e && e.detail && (e.detail.cart || e.detail);
      if (c && typeof c.total_price === 'number') updateCart(c.total_price);
      else fetchCart();
    });
  });

  /* ---------- produit ---------- */
  function productAmount(el) {
    var map;
    try { map = JSON.parse(el.getAttribute('data-variants') || '{}'); } catch (e) { return null; }
    var scope = el.closest('.t4s-section-main-product') || document;
    var idInput = scope.querySelector('[name="id"]');
    var qtyInput = scope.querySelector('[name="quantity"]');
    if (!idInput) return null;
    var unit = map[String(idInput.value)];
    if (typeof unit !== 'number') return null;
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    if (qty < 1) qty = 1;
    return unit * qty;
  }

  function updateProduct() {
    Array.prototype.forEach.call(nodes('product'), function (el) {
      var a = productAmount(el);
      if (a !== null) render(el, a);
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.name === 'id' || t.name === 'quantity') setTimeout(updateProduct, 0);
  }, true);

  document.addEventListener('input', function (e) {
    if (e.target && e.target.name === 'quantity') setTimeout(updateProduct, 0);
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest &&
        e.target.closest('[data-swatch-item], .t4s-swatch__option, [data-dropdown-item], [data-value-swatch]')) {
      setTimeout(updateProduct, 80);
    }
  }, true);

  function init() { updateProduct(); fetchCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
